var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.66663C10.6617 2.66663 8.35417 4.97413 8.35417 7.81246C8.35417 10.5966 10.5317 12.85 13.37 12.9475C13.4567 12.9366 13.5433 12.9366 13.6083 12.9475C13.63 12.9475 13.6408 12.9475 13.6625 12.9475C13.6733 12.9475 13.6733 12.9475 13.6842 12.9475C16.4575 12.85 18.635 10.5966 18.6458 7.81246C18.6458 4.97413 16.3383 2.66663 13.5 2.66663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0033 15.8291C15.9808 13.8141 11.0517 13.8141 8.0075 15.8291C6.63167 16.75 5.87334 17.9958 5.87334 19.3283C5.87334 20.6608 6.63167 21.8958 7.99667 22.8058C9.51334 23.8241 11.5067 24.3333 13.5 24.3333C15.4933 24.3333 17.4867 23.8241 19.0033 22.8058C20.3683 21.885 21.1267 20.65 21.1267 19.3066C21.1158 17.9741 20.3683 16.7391 19.0033 15.8291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.b3fd45587573f41dfe552c9b3c41b4ca.svg";
export { ForwardRef as ReactComponent };